<template>
  <card title="辅机设备">
    <div class="card_content">
      <div class="item_list fb" v-if="renderShow">
        <div class="item box_style fs" v-for="(item, index) in listData" :key="index">
          <div class="icon">
            <img :src="`${require(`@/assets/hs/${item.icon}.png`)}`" alt="" class="Img" />
          </div>
          <div class="info">
            <p class="value light" v-if="item.code == 'frontWaterLevel'">
              {{ Math.floor(item.value * 1000) / 1000 }}
            </p>
            <p class="value light" v-else>{{ formartNumber(item.value) }}</p>
            <p class="name">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Card from '@/components/Card.vue';
export default {
  name: 'FuJiSheBei',
  components: {
    Card,
  },
  data() {
    return {
      listData: [
        { code: 'frontWaterLevel', name: '前池水位(m)', icon: 'icon_2_2', value: '0' },
        { code: 'limitWaterLevel', name: '限制水位(m)', icon: 'icon_2_2', value: '300' },
        { code: 'runDay', name: '安全运行(天)', icon: 'icon_2_3', value: '2608' },
        { code: 'installedCapacity', name: '总装机(kW)', icon: 'icon_2_4', value: '37' },
        { code: 'powerSum', name: '总发电负荷(kW)', icon: 'icon_2_5', value: '35' },
        { code: 'planPowerMon', name: '月计划发电量(kW)', icon: 'icon_2_6', value: '28' },
        { code: 'powerMon', name: '月已发电量(kW)', icon: 'icon_2_7', value: '2839' },
        { code: 'planPowerYear', name: '年计划发电量(kW)', icon: 'icon_2_8', value: '220' },
        { code: 'powerYear', name: '年已发电量(kW)', icon: 'icon_2_9', value: '220' },
        { code: 'powerRateYear', name: '年完成率', icon: 'icon_2_10', value: '28' },
      ],
      stationInfo: {},
      renderShow: false,
    };
  },
  mounted() {
    this.stationInfo = this.$Storage.get('stationInfo');
    console.log('this.stationInfo :>> ', this.stationInfo);
    this.renderData();
  },
  methods: {
    formartNumber(num) {
      if (num >= 10000) {
        var formattedNumber = (num / 10000).toFixed(2) + '万';
        return formattedNumber;
      } else {
        return num.toFixed(2).toString();
      }
    },
    renderData() {
      this.listData.forEach((item, index) => {
        // this.listData[index]['value'] = this.stationInfo[item.code];
        this.$set(this.listData[index], 'value', this.stationInfo[item.code]);
        console.log('this.listData[value]', this.listData);
        this.$forceUpdate();
      });
      this.renderShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.card_content {
  .item_list {
    flex-wrap: wrap;
    .item {
      width: 234px;
      height: 132px;
      margin-bottom: 12px;
      cursor: pointer;
      .icon {
        // margin-left: 28px;
        margin-left: 13px;
      }
      .info {
        margin-left: 15px;
        .value {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
